import Pagination from '../Pagination/Pagination'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { trackCtaClick } from 'services/analyticsService'
import './SolutionsCustomerExperience.css'

const SolutionsCustomerExperience = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const casesCustomerExperience = [
    {
      id: 1,
      title: t('solutionsCustomerExperience_page.cases.items.roadmaps.title'),
      description: t('solutionsCustomerExperience_page.cases.items.roadmaps.description'),
      icon: '',
      url: 'road-maps',
    },
    {
      id: 2,
      title: t('solutionsCustomerExperience_page.cases.items.redesignFlow.title'),
      description: t(
        'solutionsCustomerExperience_page.cases.items.redesignFlow.description',
      ),
      icon: '',
      url: 'redesenho-do-fluxo',
    },
    {
      id: 3,
      title: t('solutionsCustomerExperience_page.cases.items.serviceDesignSac.title'),
      description: t(
        'solutionsCustomerExperience_page.cases.items.serviceDesignSac.description',
      ),
      icon: '',
      url: 'service-design-SAC',
    },
    {
      id: 4,
      title: t('solutionsCustomerExperience_page.cases.items.complex.title'),
      description: t('solutionsCustomerExperience_page.cases.items.complex.description'),
      icon: '',
      url: 'complex',
    },
  ]

  const handleRelatedCaseCtaClick = (caseItem) => {
    const ctaText = t('solutionsCustomerExperience_page.cases.cta')
    trackCtaClick({
      cta_name: 'solutions_related_case_click',
      cta_location: 'solutions_customer_experience',
      page_name: 'solutions_customer_experience',
      case_title: caseItem.title,
      destination_path: `/${caseItem.url}`,
      cta_text: ctaText,
    })

    navigate(`/${caseItem.url}`)
  }

  return (
    <section className="main-container solutions-cx">
      <header className="main-container-top">
        <div className="text">
          <h1>{t('solutionsCustomerExperience_page.title')}</h1>
          <p>{t('solutionsCustomerExperience_page.subtitle')}</p>
        </div>

        <div className="image-container">
          <img
            src="/assets/SolutionsPage/customer experience.png"
            alt={t('solutionsCustomerExperience_page.imageAlt')}
          />
        </div>
      </header>

      <div className="main-content">
        <div className="main-content-primary">
          <h2>{t('solutionsCustomerExperience_page.journey.title')}</h2>
          <p>{t('solutionsCustomerExperience_page.journey.p1')}</p>
          <p>{t('solutionsCustomerExperience_page.journey.p2')}</p>
          <p>{t('solutionsCustomerExperience_page.journey.p3')}</p>
          <p>{t('solutionsCustomerExperience_page.journey.p4')}</p>
        </div>
        <img
          src={t('solutionsCustomerExperience_page.journey.imageCX')}
          alt={t('solutionsCustomerExperience_page.journey.imageAlt')}
        />

        <div className="main-content-primary">
          <h2>{t('solutionsCustomerExperience_page.complexSystems.title')}</h2>
          <p>
            {t('solutionsCustomerExperience_page.complexSystems.p1')}
            <br />
            {t('solutionsCustomerExperience_page.complexSystems.p2')}
            <br />
            {t('solutionsCustomerExperience_page.complexSystems.p3')}
          </p>

          <div className="cx-ax-cards-container">
            <div className="cx-ax-card">
              <img src="/assets/Cases/CasesPage/barras.png" alt="" className="Graphic" />
              <h3>
                {t('solutionsCustomerExperience_page.complexSystems.cards.roadmap.title')}
              </h3>
              <p>
                {t(
                  'solutionsCustomerExperience_page.complexSystems.cards.roadmap.description',
                )}
              </p>
            </div>
            <div className="cx-ax-card">
              <img src="/assets/Cases/CasesPage/barras.png" alt="" className="Graphic" />
              <h3>
                {t(
                  'solutionsCustomerExperience_page.complexSystems.cards.strategy.title',
                )}
              </h3>
              <p>
                {t(
                  'solutionsCustomerExperience_page.complexSystems.cards.strategy.description',
                )}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="main-content-extra">
        <h2>{t('solutionsCustomerExperience_page.serviceDesign.title')}</h2>
        <p>{t('solutionsCustomerExperience_page.serviceDesign.p1')}</p>
        <p>{t('solutionsCustomerExperience_page.serviceDesign.p2')}</p>
        <p>{t('solutionsCustomerExperience_page.serviceDesign.p3')}</p>
        <div className="service-design-container">
          <div className="card">
            <img src="/assets/SolutionsPage/personaImage.png" alt="" />
            <div class="card-content">
              <h3>
                {t('solutionsCustomerExperience_page.serviceDesign.cards.persona.title')}
              </h3>
              <p>
                {t(
                  'solutionsCustomerExperience_page.serviceDesign.cards.persona.description',
                )}
              </p>
            </div>
          </div>
          <div className="card">
            <img src="/assets/SolutionsPage/userImage.png" alt="" />
            <div class="card-content">
              <h3>
                {t(
                  'solutionsCustomerExperience_page.serviceDesign.cards.userJourney.title',
                )}
              </h3>
              <p>
                {t(
                  'solutionsCustomerExperience_page.serviceDesign.cards.userJourney.description',
                )}
              </p>
            </div>
          </div>
        </div>

        <h2>{t('solutionsCustomerExperience_page.uxui.title')}</h2>
        <p>{t('solutionsCustomerExperience_page.uxui.p1')}</p>
        <p>{t('solutionsCustomerExperience_page.uxui.p2')}</p>
        <p>{t('solutionsCustomerExperience_page.uxui.p3')}</p>

        <div className="ui-ux-container">
          <div className="ui-ux-card">
            <img src="/assets/Cases/CasesPage/barras.png" alt="" className="Graphic" />
            <h3>{t('solutionsCustomerExperience_page.uxui.cards.designSystem.title')}</h3>
            <p>
              {t('solutionsCustomerExperience_page.uxui.cards.designSystem.description')}
            </p>
          </div>
          <div className="ui-ux-card">
            <img src="/assets/Cases/CasesPage/barras.png" alt="" className="Graphic" />
            <h3>{t('solutionsCustomerExperience_page.uxui.cards.prototypes.title')}</h3>
            <p>
              {t('solutionsCustomerExperience_page.uxui.cards.prototypes.description')}
            </p>
          </div>
          <div className="ui-ux-card">
            <img src="/assets/Cases/CasesPage/barras.png" alt="" className="Graphic" />
            <h3>{t('solutionsCustomerExperience_page.uxui.cards.usability.title')}</h3>
            <p>
              {t('solutionsCustomerExperience_page.uxui.cards.usability.description')}
            </p>
          </div>
          <div className="ui-ux-card">
            <img src="/assets/Cases/CasesPage/barras.png" alt="" className="Graphic" />
            <h3>{t('solutionsCustomerExperience_page.uxui.cards.evolution.title')}</h3>
            <p>
              {t('solutionsCustomerExperience_page.uxui.cards.evolution.description')}
            </p>
          </div>
        </div>
      </div>

      <section className="main-cases-container">
        <h2 className="title">{t('solutionsCustomerExperience_page.cases.title')}</h2>
        <p className="subtitle">{t('solutionsCustomerExperience_page.cases.subtitle')}</p>

        <Pagination
          data={casesCustomerExperience}
          itemsPerPage={4}
          autoplay={true}
          autoplayInterval={6000}
        >
          {(currentItems) => (
            <div className="main-cases-content">
              {currentItems.map((caseItem) => (
                <article key={caseItem.id} className="case-card">
                  <span>{caseItem.icon}</span>
                  <h3>{caseItem.title}</h3>
                  <p>{caseItem.description}</p>
                  <a
                    href={caseItem.link}
                    onClick={() => handleRelatedCaseCtaClick(caseItem)}
                  >
                    {t('solutionsCustomerExperience_page.cases.cta')} →
                  </a>
                </article>
              ))}
            </div>
          )}
        </Pagination>
      </section>
    </section>
  )
}

export default SolutionsCustomerExperience
